import { actionTypes as FirebaseActions } from 'react-redux-firebase';

import {
  IAddBulkOrgAddressesSuccessPayload,
  IAddedAddressesIds,
  IAddressBookState,
  IOrgAddress,
} from '../../types/addressBook';
import * as AddressBookActions from '../actions/addressBook';
import * as AuthActions from '../actions/auth';

export const initialState: IAddressBookState = {
  items: null,
  isLoading: false,
  error: null,
  invalidAddresses: null,
  addedAddressesIds: null,
};

const reducer = (state: IAddressBookState = initialState, action: any): IAddressBookState => {
  switch (action.type) {
    case AddressBookActions.FETCH_ADDRESS_BOOK_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case AddressBookActions.FETCH_ADDRESS_BOOK_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        items: null,
      };
    }
    case AddressBookActions.FETCH_ADDRESS_BOOK_SUCCESS: {
      const { address_book: responseItems } = action.payload || [];
      const items = [...(responseItems && responseItems.length ? responseItems : [])];
      return {
        ...state,
        isLoading: false,
        error: null,
        items,
      };
    }
    case AddressBookActions.ADD_ORG_ADDRESS_REQUEST:
    case AddressBookActions.EDIT_ORG_ADDRESS_REQUEST: {
      return {
        ...state,
        error: null,
        isLoading: true,
      };
    }
    case AddressBookActions.ADD_BULK_ORG_ADDRESSES_REQUEST: {
      return {
        ...state,
        error: null,
        isLoading: true,
        invalidAddresses: null,
      };
    }
    case AddressBookActions.ADD_ORG_ADDRESS_FAILURE:
    case AddressBookActions.EDIT_ORG_ADDRESS_FAILURE: {
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    }
    case AddressBookActions.ADD_BULK_ORG_ADDRESSES_FAILURE: {
      return {
        ...state,
        error: action.payload,
        isLoading: false,
        invalidAddresses: null,
      };
    }
    case AddressBookActions.ADD_ORG_ADDRESS_SUCCESS: {
      const { address, expiredAt } = action.payload;
      const items = state.items ? state.items.concat(address) : { ...address };

      const addedAddressesIds = state.addedAddressesIds
        ? { ...state.addedAddressesIds, [address.uid as string]: expiredAt }
        : { [address.uid as string]: expiredAt };

      return {
        ...state,
        isLoading: false,
        items,
        addedAddressesIds,
      };
    }
    case AddressBookActions.ADD_BULK_ORG_ADDRESSES_SUCCESS: {
      const { addresses, expiredAt } = action.payload as IAddBulkOrgAddressesSuccessPayload;
      const response = Object.values(addresses);

      const invalidAddresses = response.filter((address: IOrgAddress) => !address.success);
      const newAddresses = response.filter((address: IOrgAddress) => address.success);

      const items = state.items ? state.items.concat(newAddresses) : newAddresses;

      const newAddedIds = newAddresses.reduce((acc, address: IOrgAddress) => {
        acc[address.uid] = expiredAt;
        return acc;
      }, {} as IAddedAddressesIds);

      const addedAddressesIds = state.addedAddressesIds ? { ...state.addedAddressesIds, ...newAddedIds } : newAddedIds;

      return {
        ...state,
        isLoading: false,
        items,
        invalidAddresses,
        addedAddressesIds,
      };
    }
    case AddressBookActions.EDIT_ORG_ADDRESS_SUCCESS: {
      const items = state.items ? state.items.slice() : null;

      const index = items?.findIndex((address: IOrgAddress) => address.uid === action.payload.uid);

      if (typeof index !== 'undefined' && index !== -1) {
        items?.splice(index, 1, action.payload);
      }

      return {
        ...state,
        isLoading: false,
        items,
      };
    }
    case FirebaseActions.LOGOUT:
    case AuthActions.ADMIN_ROLE_CHANGED:
    case AuthActions.CHANGE_ORGANIZATION_SUCCESS: {
      return initialState;
    }
    case AddressBookActions.CLEAR_ADDED_ADDRESSES_IDS: {
      if (!state.addedAddressesIds) {
        return state;
      }

      const currentTime = action.payload as number;
      const filteredAddresses = Object.entries(state.addedAddressesIds).reduce((acc, [id, expiredAt]) => {
        if (expiredAt > currentTime) {
          acc[id] = expiredAt;
        }
        return acc;
      }, {} as IAddedAddressesIds);

      return {
        ...state,
        addedAddressesIds: Object.keys(filteredAddresses).length > 0 ? filteredAddresses : null,
      };
    }
    default:
      return state;
  }
};

export default reducer;
